"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = require("events");
var dispatcher_1 = __importDefault(require("../dispatcher/dispatcher"));
var validator_1 = __importDefault(require("../utils/validator"));
var FormStore = /** @class */ (function () {
    function FormStore(dispatcher) {
        var _this = this;
        this.state = this.getInitialState();
        this.eventEmitter = new events_1.EventEmitter();
        this.eventEmitter.setMaxListeners(100);
        this.dispatcher = dispatcher;
        this.dispatcher.register(function (action) {
            _this.invokeOnDispatch(action);
        });
        this.number_of_birth = 0;
    }
    FormStore.prototype.getState = function () {
        return this.state;
    };
    FormStore.prototype.getFieldKeys = function () {
        return [
            'wnumber',
            'wbirthday_year',
            'wbirthday_month',
            'wbirthday_date',
            'is_address_change',
            'after_birth_option_year',
            'after_birth_option_month',
            'after_birth_option_day',
            'email',
            'treatments',
            'outcome',
            'outcome_option',
            'outcome_num1',
            'outcome_num2',
            'number_of_birth',
            'delivery_date_year',
            'delivery_date_month',
            'delivery_date_day',
            'delivery_style',
            'is_complications',
            'is_complications_before',
            'is_complications_before_option',
            'is_complications_before_text',
            'hospital_name',
            'abortion_date_week',
            'abortion_date_day',
            'abortion_surgical_year',
            'abortion_surgical_month',
            'abortion_surgical_day',
            'fetal_sac_size',
            'chromosome_examination',
            'abortion_hospital_name',
            'gift_card'
        ];
    };
    FormStore.prototype.getChildBirthKeys = function () {
        return [
            'monozygotic_child',
            'gender',
            'weight',
            'apgar_score1',
            'apgar_score2',
            'birth_status',
            'birth_status_option',
            'birth_status_optional',
            'birth_status_optional_content',
            'birth_status_optional_text',
            'after_birth1',
            'after_birth2',
            'after_birth_option_year',
            'after_birth_option_month',
            'after_birth_option_day'
        ];
    };
    FormStore.prototype.getInitialState = function () {
        var data = [];
        var error = [];
        for (var _i = 0, _a = this.getFieldKeys(); _i < _a.length; _i++) {
            var key = _a[_i];
            if (key === "outcome"
                || key === "is_complications_before_option") {
                data[key] = [];
            }
            else {
                data[key] = '';
            }
            error[key] = '';
        }
        return { data: data, error: error, isNext: false, isComplete: false };
    };
    FormStore.prototype.on = function (event, listener) {
        this.eventEmitter.addListener(event, listener);
    };
    FormStore.prototype.removeListener = function (event, listener) {
        this.eventEmitter.removeListener(event, listener);
    };
    FormStore.prototype.emit = function (event) {
        this.eventEmitter.emit(event);
    };
    FormStore.prototype.invokeOnDispatch = function (action) {
        switch (action.type) {
            case 'change':
                if (action.params.name === 'outcome'
                    || action.params.name === "is_complications_before_option"
                    || /birth_status_optional_(.)$/.test(action.params.name)
                    || /birth_status_option_(.)$/.test(action.params.name)
                    || /birth_status_optional_content_(.)$/.test(action.params.name)) {
                    if (action.params.checked) {
                        this.state.data[action.params.name].push(action.params.value);
                    }
                    else {
                        var idx = this.state.data[action.params.name].indexOf(action.params.value);
                        this.state.data[action.params.name].splice(idx, 1);
                    }
                }
                else if (action.params.name === 'number_of_birth') {
                    this.state.data[action.params.name] = action.params.value;
                    // 出産児数が変化した場合
                    // 減らした場合は対応がいる？
                    if (this.number_of_birth < parseInt(action.params.value)) {
                        for (var current_number = this.number_of_birth + 1; current_number <= parseInt(action.params.value); current_number++) {
                            for (var _i = 0, _a = this.getChildBirthKeys(); _i < _a.length; _i++) {
                                var key = _a[_i];
                                if (key === 'birth_status_optional'
                                    || key === 'birth_status_option'
                                    || key === 'birth_status_optional_content') {
                                    this.state.data["".concat(key, "_").concat(current_number)] = [];
                                }
                                else {
                                    this.state.data["".concat(key, "_").concat(current_number)] = "";
                                }
                                this.state.error["".concat(key, "_").concat(current_number)] = [];
                            }
                        }
                        this.number_of_birth = parseInt(action.params.value);
                    }
                }
                else {
                    this.state.data[action.params.name] = action.params.value;
                }
                break;
            case 'next':
                // エラー初期化
                this.state.error = this.getInitialState().error;
                this.state.isComplete = this.getInitialState().isComplete;
                var error_msgs = [];
                var isNext = true;
                for (var param in this.state.data) {
                    var errs = (0, validator_1.default)(param, this.state.data[param]);
                    if (errs.length !== 0) {
                        isNext = false;
                        this.state.error[param] = errs;
                    }
                }
                this.state.isNext = isNext;
                break;
            case 'back':
                this.state.isNext = false;
                break;
            case 'confirm':
                this.state.isComplete = true;
                break;
            default:
                break;
        }
        return this.emit("STATE_CHANGE");
    };
    return FormStore;
}());
;
exports.default = new FormStore(dispatcher_1.default);
